import { Link } from 'react-router-dom';
import { Mail, Phone, Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-card border-t border-white/5 mt-20" data-testid="footer">
      <div className="container-luxury py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-3">
              <img 
                src="https://customer-assets.emergentagent.com/job_indyelegance/artifacts/w6jffw0x_IMG-20260221-WA0002.jpg" 
                alt="Indy Elegance" 
                className="h-16 w-16 object-contain rounded-full"
              />
              <div className="flex flex-col">
                <span className="brand-logo text-2xl gold-gradient">INDY</span>
                <span className="text-[10px] tracking-[0.3em] text-muted-foreground -mt-1">ELEGANCE</span>
              </div>
            </Link>
            <p className="text-muted-foreground mt-4 text-sm leading-relaxed">
              Elegância e sofisticação em cada peça. Descubra a lingerie que realça sua beleza natural.
            </p>
            <div className="flex gap-4 mt-6">
              <a 
                href="https://www.instagram.com/indy_cami_elegance" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-primary transition-colors"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Shop */}
          <div>
            <h4 className="text-sm uppercase tracking-[0.2em] font-bold mb-6">Comprar</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/shop/bras" className="text-muted-foreground hover:text-primary transition-colors text-sm">
                  Sutiãs
                </Link>
              </li>
              <li>
                <Link to="/shop/panties" className="text-muted-foreground hover:text-primary transition-colors text-sm">
                  Calcinhas
                </Link>
              </li>
              <li>
                <Link to="/shop/sets" className="text-muted-foreground hover:text-primary transition-colors text-sm">
                  Conjuntos
                </Link>
              </li>
              <li>
                <Link to="/shop/bodysuits" className="text-muted-foreground hover:text-primary transition-colors text-sm">
                  Bodies
                </Link>
              </li>
              <li>
                <Link to="/shop/sleepwear" className="text-muted-foreground hover:text-primary transition-colors text-sm">
                  Pijamas
                </Link>
              </li>
            </ul>
          </div>

          {/* Help */}
          <div>
            <h4 className="text-sm uppercase tracking-[0.2em] font-bold mb-6">Ajuda</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/rastrear" className="text-muted-foreground hover:text-primary transition-colors text-sm">
                  Rastrear Pedido
                </Link>
              </li>
              <li>
                <a href="#" className="text-muted-foreground hover:text-primary transition-colors text-sm">
                  Guia de Tamanhos
                </a>
              </li>
              <li>
                <a href="#" className="text-muted-foreground hover:text-primary transition-colors text-sm">
                  Envio e Entrega
                </a>
              </li>
              <li>
                <a href="#" className="text-muted-foreground hover:text-primary transition-colors text-sm">
                  Trocas e Devoluções
                </a>
              </li>
              <li>
                <a href="#" className="text-muted-foreground hover:text-primary transition-colors text-sm">
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm uppercase tracking-[0.2em] font-bold mb-6">Contato</h4>
            <ul className="space-y-4">
              <li className="flex items-center gap-3 text-sm text-muted-foreground">
                <Mail className="w-4 h-4 text-primary" />
                <a href="mailto:Alexdocivic24@gmail.com" className="hover:text-primary transition-colors">
                  Alexdocivic24@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-3 text-sm text-muted-foreground">
                <Phone className="w-4 h-4 text-primary" />
                <a href="tel:+17746227533" className="hover:text-primary transition-colors">
                  +1 (774) 622-7533
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/5 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-muted-foreground">
            © 2024 Indy Elegance. Todos os direitos reservados.
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-xs text-muted-foreground hover:text-primary transition-colors">
              Política de Privacidade
            </a>
            <a href="#" className="text-xs text-muted-foreground hover:text-primary transition-colors">
              Termos de Uso
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
